import { Collapse } from "antd";
import { useTranslation } from "react-i18next";
import { useClaimDetailsContext } from "../../ClaimDetailsContext";
import {
  ButtonConfirm,
  PanelHeaderIconButton,
} from "../../../../../Layout/Buttons";
import { IconAdd, IconModified } from "../../../../../../config/icons";
import PolicyGuaranteesList, {
  GuaranteesListItem,
} from "../../../../../Widgets/Policies/PolicyGuaranteesList";
import { useEffect, useState } from "react";
import { Guarantee } from "../../../../../../redux/apiSpecifications/apiPolicies";
import { PolicyGuaranteeModal } from "../../../../../Widgets/Policies/Forms/PolicyGuaranteeForm";
import CollapseStyled from "../../../../../../style/CollapseStyled";
import PolicyInfoForm, {
  PolicyInfoFormModal,
} from "../../../../../Widgets/Policies/Forms/PolicyInfoForm";
// import AddPolicySubjectWizardFullScreen from "../../../../../Widgets/Subjects/AddPolicySubjectWizard/AddPolicySubjectWizardFullScreen";
// import AddPolicySubjectProvider from "../../../../../Widgets/Subjects/AddPolicySubjectWizard/AddPolicySubjectContext";
import PolicySubjectsPanel from "./PolicySubjectsPanel";
import { useNotifications } from "../../../../../../hooks/useNotifications";
import { FlexWrapper } from "../../../../../../style/FlexWrapper";
import Error from "../../../../../Modals/Error";

const ClaimTabDetails = () => {
  const { t } = useTranslation();

  const {
    claim,
    onSavePolicyGuaranteePromise,
    onDeletePolicyGuaranteePromise,
  } = useClaimDetailsContext();

  const { displaySuccess, displayFetchBaseQueryErrorNotification } =
    useNotifications();

  const [policyGuarantee, setPolicyGuarantee] = useState<Guarantee | undefined>(
    undefined
  );

  const [branchesCodesToExclude, setBranchesCodesToExclude] = useState<
    string[] | undefined
  >(undefined);

  const [addPolicySubject, setAddPolicySubject] = useState<boolean>(false);

  const [showPolicyInfoModal, setShowPolicyInfoModal] =
    useState<boolean>(false);

  const handleOnAddGuarantee = () => {
    setBranchesCodesToExclude(claim?.policy?.guarantees!.map((_) => _.branch!));

    setPolicyGuarantee({} as Guarantee);
  };

  const handleOnEditPolicyGuarantee = (
    policyGuaranteesListItem: GuaranteesListItem
  ) => {
    setBranchesCodesToExclude(
      claim?.policy
        ?.guarantees!.filter((_) => _.id !== policyGuaranteesListItem.id)
        .map((_) => _.branch!)
    );

    setPolicyGuarantee(
      claim?.policy?.guarantees!.find(
        (_) => _.id === policyGuaranteesListItem.id
      )
    );
  };

  const handleOnConfirmPolicyGuaranteeMethod = (policyGuarantee: Guarantee) => {
    const policyGuaranteeToSave = { ...policyGuarantee };

    setPolicyGuarantee(undefined);

    onSavePolicyGuaranteePromise(policyGuaranteeToSave)
      .then((_) => console.info(_))
      .catch((error) => {
        Error({ error: error });
      });
  };

  const handleOnDeletePolicyGuarantee = (
    policyGuaranteesListItem: GuaranteesListItem
  ) => {
    onDeletePolicyGuaranteePromise(policyGuaranteesListItem.id!)
      .then((_) => console.info(_))
      .catch((error) => {
        Error({ error: error });
      });
  };

  const handleOnConfirmEditPolicy = () => {};

  

  return (
    <>
      <CollapseStyled
        defaultActiveKey={["policy", "guarantees", "policy-subjects"]}
      >
        <Collapse.Panel
          key={"policy"}
          header={t("PANEL-HEADERS.policy")}
          // extra={
          //   <PanelHeaderIconButton
          //     icon={<IconModified />}
          //     tooltip={t("TOOLTIPS.edit-policy")}
          //     onClick={(event) => {
          //       event.stopPropagation();

          //       setShowPolicyInfoModal(true);
          //     }}
          //   />
          // }
        >
          <FlexWrapper gap="1em" flexDirection="column">
            <FlexWrapper gap="1em" justifyContent="flex-end">
              <ButtonConfirm onClick={() => setShowPolicyInfoModal(true)}>
                {t("BUTTONS.edit-policy")!}
              </ButtonConfirm>
            </FlexWrapper>
            
            <PolicyInfoForm model={claim!} disableForm={true} />
          </FlexWrapper>
        </Collapse.Panel>

        <Collapse.Panel
          key={"guarantees"}
          header={t("PANEL-HEADERS.guarantees")}
          // extra={
          //   <PanelHeaderIconButton
          //     icon={<IconAdd />}
          //     tooltip={t("TOOLTIPS.add-guarantee")}
          //     onClick={(event) => {
          //       event.stopPropagation();

          //       handleOnAddGuarantee();
          //     }}
          //   />
          // }
        >
          <PolicyGuaranteesList
            guarantees={claim?.policy?.guarantees!}
           // onSelectItem={handleOnEditPolicyGuarantee}
            onDeleteItem={handleOnDeletePolicyGuarantee}
          />
        </Collapse.Panel>

        <Collapse.Panel
          key={"policy-subjects"}
          header={t("PANEL-HEADERS.policy-subjects")}
        >
          <PolicySubjectsPanel />
        </Collapse.Panel>
      </CollapseStyled>

      <PolicyGuaranteeModal
        open={policyGuarantee !== undefined}
        policyGuarantee={policyGuarantee}
        branchesCodesToExclude={branchesCodesToExclude}
        onCancel={() => {
          setPolicyGuarantee(undefined);
        }}
        onConfirm={handleOnConfirmPolicyGuaranteeMethod}
      />

      <PolicyInfoFormModal
        open={showPolicyInfoModal}
        claim={claim}
        onCancel={() => setShowPolicyInfoModal(false)}
        onConfirm={handleOnConfirmEditPolicy}
      />
    </>
  );
};

export default ClaimTabDetails;
